import type { LucideIcon } from 'lucide-react'
import * as React from 'react'
import { forwardRef } from 'react'

export const SwitchIcon: LucideIcon = forwardRef(({ size = 24, color = 'currentColor', ...props }, ref) => {
  return (
    <svg
      ref={ref}
      width={size}
      height={size}
      viewBox='0 0 20 20'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M0 12.6488C0 12.12 0.422371 11.6914 0.943392 11.6914H19.0565C19.4501 11.6914 19.8023 11.9393 19.9401 12.3134C20.078 12.6875 19.9725 13.1092 19.6756 13.3713L12.4303 19.765C12.0371 20.112 11.4413 20.0698 11.0994 19.6708C10.7575 19.2718 10.7991 18.6671 11.1922 18.3201L16.5339 13.6062H0.943392C0.422371 13.6062 0 13.1775 0 12.6488Z'
        fill={color}
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M20 7.35117C20 7.87993 19.5776 8.30857 19.0566 8.30857L0.943479 8.30857C0.54992 8.30857 0.197712 8.06063 0.0598562 7.68653C-0.0780006 7.31243 0.0274631 6.89079 0.324445 6.62871L7.5697 0.234954C7.96286 -0.112004 8.55874 -0.069814 8.90062 0.329188C9.2425 0.728191 9.20093 1.33291 8.80777 1.67987L3.46609 6.39377L19.0566 6.39377C19.5776 6.39377 20 6.82242 20 7.35117Z'
        fill={color}
      />
    </svg>
  )
})

SwitchIcon.displayName = 'SwitchIcon'
